module.exports = __webpack_public_path__ + "static/media/tablet1.1af4dadf.png";